/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sidebar__body[_ngcontent-%COMP%]{padding-top:0}.sidebar__info[_ngcontent-%COMP%]{border-bottom:none}#add_section[_ngcontent-%COMP%]{border-top:1px solid #dbdbdb;border-bottom:1px solid #dbdbdb;padding:20px 0 25px;margin-top:20px}#vantages_section[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-top:30px}#conditions_section[_ngcontent-%COMP%]{padding-top:10px}#terms_section[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{margin-bottom:1.5rem}#close_section[_ngcontent-%COMP%]{margin-top:50px;border-top:1px solid #dbdbdb}"];
export { styles as styles };
